import type { CsvWorkerApi } from "./worker/submissionsParticipantsToCsv";
import csvWorkerUrl from "./worker/submissionsParticipantsToCsv?worker&url";
import type { DataUtilsApi } from "./worker/dataUtils";
import dataUtilsWorkerUrl from "./worker/dataUtils?worker&url";

export enum WorkerKey {
  SubmissionsParticipantsToCsv,
  DataUtils,
}

export type ApiMapping = {
  [WorkerKey.SubmissionsParticipantsToCsv]: CsvWorkerApi;
  [WorkerKey.DataUtils]: DataUtilsApi;
};

export const UrlMapping = {
  [WorkerKey.SubmissionsParticipantsToCsv]: csvWorkerUrl,
  [WorkerKey.DataUtils]: dataUtilsWorkerUrl,
};
